export const DATE_FORMAT = 'DD-MM-YYYY';
export const DDMMMYYYY_FORMAT='DD MMM YYYY';
export const TIME_FORMAT='HH:mm';